
  import commonUtils from '~/mixins/pages/mission-control/commonUtils'
  import exchangeReward from '~/mixins/pages/mission-control/exchangeReward'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  export default {
    name: 'Theme2MissionDesktopExchangeRewardPage',
    mixins: [exchangeReward, vipSettings, commonUtils],
    computed: {
      tiersList() {
        if (this.vipTiers?.tiers?.length)
          return this.vipTiers.tiers?.filter(el => el.tier_type === 1)
        return []
      }
    },
    mounted() {
      this.getVipSettings() // It's from mixins->vipSettings.js
      this.getPlayerVipTier() //  mixins->vipSettings.js
    }
  }
